export const notUndefined = <T>(x: T | undefined): x is T => x !== undefined;

export const notNull = <T>(x: T | null): x is T => x !== null;

export const isResponse = (response: unknown): response is Response =>
	Boolean(response && typeof response === "object" && "json" in response);

export const hasSingleItem = <T>(arr: T[]): arr is [T] => arr.length === 1;

export const nonEmptyArray = <T>(arr: T[]): arr is [T, ...T[]] =>
	arr.length > 0;

export const isValidType = <T extends string | number>(
	value: unknown,
	validValues: T[] | readonly T[],
): value is T => validValues.includes(value as T);
